import { render, staticRenderFns } from "./PracticeAreaVendors.vue?vue&type=template&id=787e4652"
import script from "./PracticeAreaVendors.vue?vue&type=script&lang=js"
export * from "./PracticeAreaVendors.vue?vue&type=script&lang=js"
import style0 from "./PracticeAreaVendors.vue?vue&type=style&index=0&id=787e4652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports